import React, { useContext, useState } from 'react'
import Button from '@mui/material/Button'
import ButtonGroup from '@mui/material/ButtonGroup'
import Stack from '@mui/material/Stack'
import Typography from '@mui/material/Typography'
import { ActionPanelItem } from './EmployeeApplicationActionPanel'
import SmallModal from '../../../components/Modals/SmallModal'
import BigModal from '../../../components/Modals/BigModal'
import API from '../../../services/API'
import { useNavigate } from 'react-router-dom'
import { GlobalContext } from '../../../App'
import { TextField } from '@mui/material'

const RejectApplication = ({ applicationID, disabled }) => {
  const [openConfirmation, setOpenConfirmation] = useState(false)
  const navigate = useNavigate()
  const { setToast } = useContext(GlobalContext)
  const [reason, setReason] = useState('')
  const handleRejection = () => {
    API.post('/reject-employees-application', {
      applicationID,
      reason,
    })
      .then((res) => {
        if (res.status === 200) {
          navigate('/employees/applications')
          setToast({ message: 'Application Rejected' })
          return
        }
        // API.js never rejects on a non-2xx, so without this a failed
        // rejection left the dialog open with no feedback at all.
        setToast({
          severity: 'error',
          message:
            res?.data?.error ||
            'Could not reject this application. Please try again.',
        })
      })
      .catch(() => {
        setToast({
          severity: 'error',
          message: 'Could not reject this application. Please try again.',
        })
      })
  }
  return (
    <ActionPanelItem>
      <Button
        variant="outlined"
        color="error"
        fullWidth
        size="small"
        onClick={() => setOpenConfirmation(true)}
        disabled={disabled}
      >
        Reject Application
      </Button>
      <BigModal
        autoWidth
        open={openConfirmation}
        onClose={() => setOpenConfirmation(false)}
      >
        <Stack gap={1} alignItems="center">
          <Typography variant="title3">
            Are you sure you want to reject this application?
          </Typography>
          <Typography variant="caption">
            Doing so will notify the applicant and delete their account.
          </Typography>
          <TextField
            value={reason}
            onChange={(e) => setReason(e.target.value)}
            fullWidth
            minRows={2}
            multiline
            title="Reason for Rejection"
            placeholder="Reason for Rejection"
            helperText="Provide a reason for rejection that will be sent to the applicant. This is optional, and a generic email will be sent if no reason is provided."
          />
          <ButtonGroup>
            <Button
              variant="outlined"
              color="error"
              onClick={() => setOpenConfirmation(false)}
            >
              Cancel
            </Button>
            <Button
              variant="contained"
              color="error"
              onClick={() => handleRejection()}
            >
              Reject
            </Button>
          </ButtonGroup>
        </Stack>
      </BigModal>
    </ActionPanelItem>
  )
}

export default RejectApplication
